<template>
  <div class="menu-container">
    <div class="search-bar">
      <label>搜索：</label>
      <input type="text" v-model="searchName" placeholder="输入用户名称" />
      <button class="search-button" @click="searchOrders">搜索</button>
      <button class="export-button" @click="exportSummary">统计总表导出</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户</th>
          <th>金额</th>
          <th>早餐</th>
          <th>午餐</th>
          <th>晚餐</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.id">
          <td>{{ order.id }}</td>
          <td>{{ order.name }}</td>
          <td>{{ order.money }}</td>
          <td>{{ order.zaocan }}</td>
          <td>{{ order.wucan }}</td>
          <td>{{ order.wancan }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      searchName: '',
      orders: [],
      filteredOrders: []
    };
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await this.$axios.get('/api/show_tongxunlu');
        const data = response.data;
        if (data.code === 0) {
          this.orders = data.data.map(order => ({
            id: order.id,
            name: order.name,
            money: order.money,
            zaocan: order.zaocan,
            wucan: order.wucan,
            wancan: order.wancan
          }));
          this.filteredOrders = this.orders; // 初始化显示所有订单
        } else {
          console.error('Failed to fetch orders:', data.message);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    },
    searchOrders() {
      this.filteredOrders = this.orders.filter(order => 
        order.name.toLowerCase().includes(this.searchName.toLowerCase())
      );
    },
    exportSummary() {
      // 定义导出的列名（与页面表格列名一致）

      // 将 orders 数据转换为带有列名的数组
      const dataWithHeaders = this.orders.map(order => ({
        ID: order.id,
        用户: order.name,
        金额: order.money,
        早餐: order.zaocan,
        午餐: order.wucan,
        晚餐: order.wancan
      }));

      // 创建工作表
      const worksheet = XLSX.utils.json_to_sheet(dataWithHeaders);

      // 创建工作簿
      const workbook = XLSX.utils.book_new();

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders');

      // 导出为 Excel 文件
      XLSX.writeFile(workbook, 'orders_summary.xlsx');
    }
  },
  mounted() {
    this.fetchOrders();
  }
};
</script>

<style scoped>
.menu-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

.search-bar input,
.search-bar button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.search-button {
  background-color: #007bff;
  color: white;
}

.export-button {
  background-color: #dc3545;
  color: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}
</style>